module.exports = "/_next/static/images/icon-market-trade-5a6251c569a07102cefb367cd55f6ea5.svg";